import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
/* istanbul ignore file */
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from 'react';
import { useWindowSize } from 'react-use';
import { toSentenceCase } from '@noths/polaris-client-utils';
import * as styles from "./Breadcrumbs.styles";
var FADE_MIN_THRESHOLD_IN_PX = 10;
export var Breadcrumbs = function Breadcrumbs(_ref) {
  var links = _ref.links,
    onLinkClick = _ref.onLinkClick;
  var _useWindowSize = useWindowSize(),
    width = _useWindowSize.width;
  var containerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldShowLeftFade = _useState2[0],
    setShouldShowLeftFade = _useState2[1];
  var getLinkDepth = function getLinkDepth(index) {
    return links.length - index;
  };
  var handleOnScroll = function handleOnScroll(_ref2) {
    var target = _ref2.target;
    return setShouldShowLeftFade(target.scrollLeft >= FADE_MIN_THRESHOLD_IN_PX);
  };
  useEffect(function () {
    if (containerRef.current) {
      containerRef.current.scrollLeft = containerRef.current.scrollWidth;
    }
  }, [containerRef, width]);
  var _onClick = function onClick(e, index) {
    onLinkClick === null || onLinkClick === void 0 || onLinkClick(e, {
      linkDepth: getLinkDepth(index)
    });
  };
  return /*#__PURE__*/React.createElement(_StyledNav, {
    "aria-label": "Breadcrumb",
    "data-left-fade-visible": shouldShowLeftFade,
    $_css: styles.breadcrumbNav
  }, /*#__PURE__*/React.createElement(_StyledOl, {
    onScroll: handleOnScroll,
    ref: containerRef,
    $_css2: styles.breadcrumbList
  }, links.map(function (link, index) {
    return /*#__PURE__*/React.createElement(_StyledLi, {
      key: link.text,
      $_css3: styles.breadcrumbListItem
    }, /*#__PURE__*/React.createElement(_StyledA, {
      href: link.rel,
      onClick: function onClick(e) {
        return _onClick(e, index);
      },
      $_css4: styles.breadcrumbLink
    }, toSentenceCase(link.text.toLowerCase())));
  })));
};
var _StyledNav = _styled("nav")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledOl = _styled2("ol")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledLi = _styled3("li")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledA = /*#__PURE__*/_styled4("a").withConfig({
  displayName: "Breadcrumbs___StyledA",
  componentId: "sc-150hbce-0"
})(["", ""], function (p) {
  return p.$_css4;
});